function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondBannerMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 300,
    viewBox: "0 0 375 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 300,
    fill: "url(#paint0_linear_15_327)",
    style: {}
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15_327",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 375,
    height: 300
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 300,
    fill: "url(#paint1_linear_15_327)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15_327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.136 -116.298C288.474 -39.0639 302.949 107.171 499.427 124.694",
    stroke: "#A8A8A8",
    style: {
      stroke: "#A8A8A8",
      stroke: "color(display-p3 0.6588 0.6588 0.6588)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.6 -68.2976C323.938 8.93609 338.413 155.171 534.891 172.694",
    stroke: "#A8A8A8",
    style: {
      stroke: "#A8A8A8",
      stroke: "color(display-p3 0.6588 0.6588 0.6588)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_327",
    x1: 187.5,
    y1: 0,
    x2: 187.5,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#332BD2",
    stopOpacity: 0.2,
    style: {
      stopColor: "#332BD2",
      stopColor: "color(display-p3 0.2006 0.1684 0.8250)",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2A8B",
    stopOpacity: 0.1,
    style: {
      stopColor: "#2F2A8B",
      stopColor: "color(display-p3 0.1846 0.1660 0.5458)",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15_327",
    x1: 187.5,
    y1: 0,
    x2: 187.5,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#332BD2",
    stopOpacity: 0.2,
    style: {
      stopColor: "#332BD2",
      stopColor: "color(display-p3 0.2006 0.1684 0.8250)",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2A8B",
    stopOpacity: 0.1,
    style: {
      stopColor: "#2F2A8B",
      stopColor: "color(display-p3 0.1846 0.1660 0.5458)",
      stopOpacity: 0.1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondBannerMobile);
export default __webpack_public_path__ + "static/media/second_banner_mobile.863b6c8c0abd91617221dd3d60f41082.svg";
export { ForwardRef as ReactComponent };